import React, { useState, useMemo } from 'react';
import './Penalties.css';

const PENALTY_DATA = [
    ['Blacklisted Begriff der Kategorie [A]', 'WARN', ''],
    ['Blacklisted Begriff der Kategorie [B]', 'Perma - BAN', 'Mit Chance auf Entbannung'],
    ['Unerlaubte salerno City Grafische Modifikationen', '1 Stunde', 'Vorzeigen im Support'],
    ['Teamler im Aduty oder IC Ansprechen', 'WARN', ''],
    ['FiveM Namen unpassend', 'WARN', ''],
    ['Fail RP allgemein', 'WARN - 1 Std', 'Je nach Vergehen'],
    ['FailRP: Benutzen von defekten Fahrzeugen', 'WARN', ''],
    ['FailRP: VOL / Leben nicht geschützt', 'WARN', ''],
    ['FFA zur Flucht benutzt', 'WARN', ''],
    ['RDM (Random Deathmatch)', 'WARN', ''],
    ['OOC Talk im RP', 'WARN', ''],
    ['Krankheiten ausspielen', 'WARN', ''],
    ['Teamler Beleidigen', 'PERMA', 'Bei Entschuldigung kann dieser Revoke werden'],
    ['Bug Abuse', 'WARN', ''],
    ['VDM (Vehicle Deathmatch)', 'WARN', ''],
    ['Power RP', 'WARN - 2 Stunden', 'Je nach Vergehen'],
    ['New Life Regel nicht beachtet', 'WARN', ''],
    ['Ninja RP', 'WARN', ''],
    ['Staatliche Fahrzeuge klauen (Ohne RP Hintergrund)', 'WARN', ''],
    ['Staatliche Waffen abnehmen/weitergeben', 'WARN - 1 Stunde', ''],
    ['Baiting', 'WARN', ''],
    ['Meta Gaming', 'WARN - 2 Stunden', 'Je nach Ausmaß'],
    ['Fantasy RP / Ausgedachte Gegenstände', 'WARN', ''],
    ['Bewusstlose Spieler Schändigung', 'WARN - Perma', 'Je nach Ausmaß'],
    ['Drive-By aus Import / Motorräder', 'WARN', ''],
    ['Emoteabuse', 'WARN', ''],
    ['Combatlogging', '1 Stunde', ''],
    ['Sexuelle Belästigung', '4 Std - PermaBANN', 'Je nach Ausmaß']
];

const BLACKLIST_A = `
Beleidigungen
N-Wort

Homophobe Sprüche
Sonstige Diskriminierungen`;

const BLACKLIST_B = `
Rassismus
Sexuelle Inhalte
Gewaltverherrlichung
Illegale Symbolische Darstellungen
Sonstige extremistische Inhalte`;

const Penalties = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [showBlacklistA, setShowBlacklistA] = useState(false);
    const [showBlacklistB, setShowBlacklistB] = useState(false);

    const filteredPenalties = useMemo(() => {
        return PENALTY_DATA.filter(p =>
            p[0].toLowerCase().includes(searchTerm.toLowerCase()) ||
            p[1].toLowerCase().includes(searchTerm.toLowerCase())
        );
    }, [searchTerm]);

    const getSeverityStyle = (time) => {
        const t = time.toLowerCase();
        if (t.includes('perma') || t.includes('4 std')) return 'perma';
        if (t.includes('warn')) return 'warn';
        if (t.match(/\d+\s*(stunde|min)/i)) return 'time';
        if (t.includes('2 std') || t.includes('3 std')) return 'time-orange';
        return 'default';
    };

    return (
        <div className="penalties-container">
            <div className="penalties-card">
                <div className="penalties-header">
                    <div className="penalties-title">
                        <div className="penalties-title-icon">
                            <i className="fas fa-terminal"></i>
                        </div>
                        <h4>DATABASE::SANKTIONSKATALOG</h4>
                    </div>
                    <div className="penalties-search">
                        <span className="penalties-search-icon">
                            <i className="fas fa-search"></i>
                        </span>
                        <input
                            type="text"
                            className="penalties-search-input"
                            placeholder="Geben Sie einen Verstoß oder eine Dauer ein..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                </div>

                <div className="penalties-body">
                    <div className="penalties-alert">
                        <i className="fas fa-exclamation-triangle"></i>
                        <span>
                            <strong>SYSTEM NOTICE:</strong> Alle Werte sind Basis-Sanktionen. Multiplikator bei Eingestehen möglich.
                        </span>
                    </div>

                    <div className="penalties-table-container">
                        <table className="penalties-table">
                            <thead>
                                <tr>
                                    <th className="penalties-col-violation">Verstoß</th>
                                    <th className="penalties-col-duration">Dauer</th>
                                    <th className="penalties-col-info">Zusatz Info</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredPenalties.map((penalty, index) => (
                                    <tr key={index}>
                                        <td>
                                            <div className="penalties-violation">
                                                <span className="penalties-violation-icon">{'>'}</span>
                                                {penalty[0]}
                                            </div>
                                        </td>
                                        <td>
                                            <span className={`penalties-badge ${getSeverityStyle(penalty[1])}`}>
                                                {penalty[1]}
                                            </span>
                                        </td>
                                        <td>
                                            <span className="penalties-info">
                                                {penalty[2] ? `// ${penalty[2]}` : '---'}
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        {filteredPenalties.length === 0 && (
                            <div className="penalties-empty">
                                [!] KEINE DATENSÄTZE GEFUNDEN
                            </div>
                        )}
                    </div>
                </div>

                {/* Blacklist Sections */}
                <div className="penalties-blacklist">
                    {/* Blacklisted Kategorie A */}
                    <div className="penalties-blacklist-item">
                        <button
                            className="penalties-blacklist-btn"
                            onClick={() => setShowBlacklistA(!showBlacklistA)}
                        >
                            <span>
                                <i className={`fas fa-chevron-${showBlacklistA ? 'down' : 'right'} me-2`}></i>
                                BLACKLISTED KATEGORIE [A]
                            </span>
                            <i className={`fas fa-chevron-${showBlacklistA ? 'up' : 'down'}`}></i>
                        </button>
                        {showBlacklistA && (
                            <div className="penalties-blacklist-content category-a">
                                <table className="penalties-blacklist-table">
                                    <thead>
                                        <tr>
                                            <th className="category-a">BLACKLISTED KATEGORIE [A]</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {BLACKLIST_A.split('\n').filter(term => term.trim()).map((term, idx) => (
                                            <tr key={idx}>
                                                <td>
                                                    <span className="penalties-blacklist-icon">{'>'}</span>
                                                    {term.trim()}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>

                    {/* Blacklisted Kategorie B */}
                    <div className="penalties-blacklist-item">
                        <button
                            className="penalties-blacklist-btn"
                            onClick={() => setShowBlacklistB(!showBlacklistB)}
                        >
                            <span>
                                <i className={`fas fa-chevron-${showBlacklistB ? 'down' : 'right'} me-2`}></i>
                                BLACKLISTED KATEGORIE [B]
                            </span>
                            <i className={`fas fa-chevron-${showBlacklistB ? 'up' : 'down'}`}></i>
                        </button>
                        {showBlacklistB && (
                            <div className="penalties-blacklist-content category-b">
                                <table className="penalties-blacklist-table">
                                    <thead>
                                        <tr>
                                            <th className="category-b">BLACKLISTED KATEGORIE [B]</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {BLACKLIST_B.split('\n').filter(term => term.trim()).map((term, idx) => (
                                            <tr key={idx}>
                                                <td>
                                                    <span className="penalties-blacklist-icon">{'>'}</span>
                                                    {term.trim()}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Penalties;
